// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__4Hc8e","clinicsSelect":"TableHeading_clinicsSelect__IebdD"};